import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect, useDispatch } from 'react-redux';

import { Link, useNavigate } from 'react-router-dom';

// Redux Store
import { showRightSidebarAction, toggleLeftmenu } from 'store/actions';
// reactstrap
import { Row, Col, Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

// Import menuDropdown
import LanguageDropdown from 'components/CommonForBoth/TopbarDropdown/LanguageDropdown';
import ShopsDropdown from 'components/CommonForBoth/TopbarDropdown/ShopsDropdown';

import megamenuImg from 'assets/images/megamenu-img.png';
import logo from 'assets/images/logo.svg';
import logoLight from 'assets/images/logo-light.png';
import logoLightSvg from 'assets/images/logo-light.svg';
import logoDark from 'assets/images/logo-dark.png';

// import images
import github from 'assets/images/brands/github.png';
import bitbucket from 'assets/images/brands/bitbucket.png';
import dribbble from 'assets/images/brands/dribbble.png';
import dropbox from 'assets/images/brands/dropbox.png';
import mail_chimp from 'assets/images/brands/mail_chimp.png';
import slack from 'assets/images/brands/slack.png';

//i18n
import { withTranslation } from 'react-i18next';
import SelectMedicineSearch from 'components/Common/MedicineSearchSelect';
import { addMedicineToTab, addTab, setActiveTab } from 'store/sales-invoice/saleInvoice.actions';
import ProfileMenu from 'components/CommonForBoth/TopbarDropdown/ProfileMenu';

const Header = (props) => {
  const [menu, setMenu] = useState(false);
  const [isSearch, setSearch] = useState(false);
  const [socialDrp, setsocialDrp] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
  }

  const handleMedicineSearch = (selected) => {
    const newTabId = `invoice-${Date.now()}`;
    if (selected) {
      dispatch(addTab(newTabId, newTabId));
      dispatch(addMedicineToTab(newTabId, { ...selected, units: 1 }));
      dispatch(setActiveTab(newTabId));
      navigate('/sales/invoices/add');
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoDark} alt="" height="17" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
                <span className="logo-lg">
                  <img src={logoLight} alt="" height="19" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          <div className="d-flex flex-grow-1 mx-4">
            <div className="app-search d-none d-sm-block flex-grow-1 mx-4">
              {/* <SelectMedicineSearch
                isUrdu={false}
                width="100%"
                onMedicineSelect={handleMedicineSearch}
              /> */}
            </div>

            <div className="dropdown d-inline-block d-sm-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? 'dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show'
                    : 'dropdown-menu dropdown-menu-lg dropdown-menu-end p-0'
                }
                aria-labelledby="page-header-search-dropdown"
              >
                {/* <SelectMedicineSearch
                  isUrdu={false}
                  width="100%"
                  onMedicineSelect={handleMedicineSearch}
                /> */}
              </div>
            </div>
          </div>

          <div className="d-flex">
            <LanguageDropdown />

            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                className="btn header-item noti-icon "
                onClick={() => {
                  toggleFullscreen();
                }}
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>

            {/* <ShopsDropdown /> */}

            <ProfileMenu />

            {/* <div className="dropdown d-inline-block">
              <button
                onClick={() => {
                  props.showRightSidebarAction(!props.showRightSidebar);
                }}
                type="button"
                className="btn header-item noti-icon right-bar-toggle "
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
